import cx from 'classnames'

import {
  styles,
  tableOverflowStyles,
  wrapperOverflowStyles,
} from './table.styles'
import { TableRow } from './row'
import type { TableProps } from './table.types'

export function Table({
  headRows,
  bodyRows,
  overflow = 'scroll',
  className = '',
  tableClassName = '',
  ...tableProps
}: TableProps) {
  return (
    <div
      className={cx(styles.wrapper, wrapperOverflowStyles[overflow], className)}
    >
      <table
        className={cx(
          styles.table,
          tableOverflowStyles[overflow],
          tableClassName,
        )}
        {...tableProps}
      >
        {headRows.length > 0 && (
          <thead>
            {headRows.map((row, rowIndex) => (
              <TableRow key={`head-row-${rowIndex}`} isHeading {...row} />
            ))}
          </thead>
        )}
        {bodyRows.length > 0 && (
          <tbody>
            {bodyRows.map((row, rowIndex) => (
              <TableRow
                key={`body-row-${rowIndex}`}
                isHeading={false}
                {...row}
              />
            ))}
          </tbody>
        )}
      </table>
    </div>
  )
}
